import { css } from 'emotion';

export default css`
  max-width: 80rem;
  .form-border {
    margin: 2rem 0;
  }
`
